class Blockquote {
  init = () => {
    const blockquoteElements: NodeListOf<HTMLElement> = document.querySelectorAll('blockquote');
     
    if (!blockquoteElements.length) {
      return;
    }

    Array.prototype.map.call(blockquoteElements, (element) => {
      if(element.querySelector('span') === null) {
        element.firstChild.classList.add('blockquote-icon');
      }
    });
  };
}

const blockquoteInstance = new Blockquote();
blockquoteInstance.init();

export { Blockquote, blockquoteInstance };
